import { createContext } from "react";

import { observable, action, computed } from "mobx";

/** Legacy MobX-backed context used by some song list UIs (`proAccount`, etc.). */
class LegacyArtistStore {
  @observable
  public artist?: Artist;

  @observable
  public proAccount?: boolean = false;

  @action
  public setProAccount = () => {
    this.proAccount = true;
  };

  @action
  public setArtist = (artist?: Artist) => {
    this.artist = artist;
  };

  @computed
  public get _id() {
    return this.artist?._id;
  }
}

export const store = new LegacyArtistStore();

const ArtistContext = createContext(store);

export default ArtistContext;
